import { cilSpeedometer, cilGroup, cilCheck } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import { CNavTitle, CNavItem } from '@coreui/react-pro';
import { SUBSCRIBER_PATH } from '../constants';

const subscriberOrgNav = [
     {
          component: CNavItem,
          name: 'Dashboard',
          to: '/my-organization',
          icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
     },
     {
          component: CNavTitle,
          name: 'MANAGE USERS',
          membercanaccess: 'false', // Hide this item from user has role member of an organization
     },
     {
          component: CNavItem,
          name: 'Organization Members',
          to: SUBSCRIBER_PATH.ORGANIZATIONS_ORG_MEMBERS,
          icon: <CIcon icon={cilCheck} customClassName="nav-icon" />,
          membercanaccess: 'false',
     },
     {
          component: CNavItem,
          name: 'Training Groups',
          to: '/my-organization/training-groups',
          icon: <CIcon icon={cilGroup} customClassName="nav-icon" />,
          membercanaccess: 'false',
     },

     {
          component: CNavTitle,
          name: 'MANAGE SEATS',
     },
     {
          component: CNavTitle,
          name: 'REPORTING & DATA',
     },
];

export default subscriberOrgNav;
